<template>
  <div>
    <ts-card>
      <ts-card-wrapper class="ts-flex ts-whitespace-no-wrap ts-justify-between">
        <div class="row">
          <div class="d-flex justify-content-end">
            <ts-input v-model="search" :placeholder="$t('academicYear.searchOnlyAcademicYearColumn')" class="kh-font" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="d-flex justify-content-end">
            <ts-button outline class="ml-2" v-tooltip="$t('filter')" @click.prevent="visible = true">
              <i class="fa fa-filter"></i>
            </ts-button>
            <a-drawer :title="$t('filter')" placement="right" :closable="false" :visible="visible"
              @close="() => (visible = false)" :zIndex="1020" width="300px">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <a-select style="width: 257px" v-model="branch_id" :options="branchs" showSearch mode="multiple"
                      :filterOption="(input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                        " :maxTagCount="1" :maxTagTextLength="17" :placeholder="$t('all')">
                    </a-select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label> {{ $t('academicYear.status') }}</label>
                    <a-select style="width: 257px" v-model="ac_status_id" :options="status" showSearch mode="multiple"
                      :filterOption="(input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                        " :maxTagCount="1" :maxTagTextLength="17" :placeholder="$t('all')">
                    </a-select>
                  </div>
                </div>
              </div>
            </a-drawer>
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>
            {{ record.branch ? record.branch.branch_name_en : '' }}
          </td>
          <td>{{ record.ac_year }}</td>
          <td>{{ record.ac_start }}</td>
          <td>{{ record.ac_stop }}</td>
          <td>{{ record.ac_status.ac_status_description }}</td>
          <td>{{ batches(record) }}</td>
          <td class="text-center">
            <a href="#" title="edit" class="text-primary mr-2" @click.prevent="edit(record)">
              <i class="fas fa-edit"></i>
            </a>
            <a href="#" title="delete" class="text-danger" @click.prevent="destroy(record)">
              <i class="fas fa-circle-notch spin spiner" v-if="record._deleting"></i>
              <i class="fas fa-trash" v-if="record._deleting == false"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'
export default {
  name: 'academic-year-table',
  props: ['fetch'],
  data() {
    return {
      loading: false,
      visible: false,
      branchs: [],
      status: [],
      columns: [
        { name: this.$t('academicYear.branch') },
        { name: this.$t('academicYear.academicYear') },
        { name: this.$t('academicYear.beginDate') },
        { name: this.$t('academicYear.endDate') },
        { name: this.$t('academicYear.status') },
        { name: this.$t('academicYear.batches') },
        { name: this.$t('action'), style: 'text-align:center; width:5%' }
      ]
    }
  },
  created() {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.fetchData()
    this.getBranch()
    this.getStatus()
  },
  computed: {
    ...mapState('academicYear', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.academicYear.search
      },
      set(newVal) {
        this.$store.commit('academicYear/SET_SEARCH', newVal)
        this.$store.commit('academicYear/RESET_CURRENT_PAGE')
      }
    },
    branch_id: {
      get() {
        return this.$store.state.academicYear.branch_id
      },
      set(newValue) {
        this.$store.commit('academicYear/SET_BRANCH_ID', newValue)
      }
    },
    ac_status_id: {
      get() {
        return this.$store.state.academicYear.ac_status_id
      },
      set(newValue) {
        this.$store.commit('academicYear/SET_STATUS_ID', newValue)
      }
    }
  },
  methods: {
    batches(record) {
      return record.batches.map(item => item.batch_name).join(', ')
    },
    fetchData(attribute) {
      this.loading = true
      this.$store
        .dispatch(
          'academicYear/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attribute }
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    getBranch() {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    edit(record) {
      this.$store.commit('academicYear/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'academic-year-edit',
        params: { id: record.ac_year_id }
      })
    },

    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('academicYear/destroy', record.ac_year_id)
          .then(response => {
            record._deleting = false
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            record._deleting = false
            this.$toasted.error(error.message)
          })
      }
    },
    getStatus() {
      this.$store
        .dispatch('academicYear/getStatus')
        .then(response => {
          this.status = response.map(el => ({
            value: el.ac_status_id,
            label: el.ac_status_description
          }))
        })
    },
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value })
    }, 500),
    ac_status_id: debounce(function (value) {
      this.fetchData({ ac_status_id: value })
    }, 500),

    fetch: function (value) {
      if (value) {
        this.fetchData()
        this.$emit('fetched')
      }
    }
  }
}
</script>
